window.addEventListener('load', function() {
    const holidaysTable = document.querySelector('.meals-holidays table');
    if (holidaysTable) {
        const MealHoliday = require('../modules/MealHoliday');
        var mod = new MealHoliday(holidaysTable, {});
    }

    const mealsManageEl = document.querySelector('.meals-manage');
    if (mealsManageEl) {
        const MealsManage = require('../modules/MealsManage');
        var mod = new MealsManage(mealsManageEl, {});
    }

    const mealsBuildEl = document.querySelector('.meals-build');
    if (mealsBuildEl) {
        const MealsBuild = require('../modules/MealsForm');
        var mod = new MealsBuild(mealsBuildEl, {});
    }
});